import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Conversations/MessageAttachments.tsx
import { MdDescription } from "react-icons/md";
import { formatBytes } from "../../../domain/attachments/index.mjs";
import { ImageFrame } from "../../primitive/index.mjs";
import { useConversationsTranslation } from "./use-conversations-translation.mjs";
import { fileTypeCue } from "./utils.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function MessageAttachments({ attachments }) {
  const { t, i18n } = useConversationsTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  return /* @__PURE__ */ jsx("div", { className: "bs-conversations__attachments", children: attachments.map((attachment, index) => {
    const key = `${attachment.fileID ?? attachment.url ?? attachment.contentType}-${index}`;
    const isImage = typeof attachment.contentType === "string" && attachment.contentType.startsWith("image/");
    const size = attachment.size != null ? formatBytes(attachment.size, locale) : void 0;
    if (attachment.url && !isImage) {
      const meta = [fileTypeCue(attachment.fileName), size].filter(Boolean).join(" \xB7 ");
      return /* @__PURE__ */ jsxs("a", { className: "bs-conversations__attachment bs-conversations__attachment-file", href: attachment.url, target: "_blank", rel: "noopener noreferrer", children: [
        /* @__PURE__ */ jsx(MdDescription, { "aria-hidden": true }),
        /* @__PURE__ */ jsxs("span", { className: "bs-conversations__file-info", children: [
          /* @__PURE__ */ jsx("span", { dir: "auto", children: attachment.fileName || t("shared.chat.log.attachment.open") }),
          meta && /* @__PURE__ */ jsx("small", { children: meta })
        ] })
      ] }, key);
    }
    const reason = typeof attachment.reason === "string" ? attachment.reason : "unknown";
    const reasonKey = reason.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    return /* @__PURE__ */ jsxs("div", { className: "bs-conversations__attachment", children: [
      attachment.url ? /* @__PURE__ */ jsx("a", { href: attachment.url, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsx(ImageFrame, { className: "bs-conversations__attachment-frame", imgClassName: "bs-conversations__attachment-image", src: attachment.url, alt: t("shared.chat.log.attachment.image_alt"), fallback: "alt", loading: "lazy" }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("strong", { children: t("shared.chat.log.attachment.unavailable") }),
        /* @__PURE__ */ jsx("span", { children: t(`shared.chat.log.attachment.reason.${reasonKey}`, { defaultValue: t("shared.chat.log.attachment.reason.unknown") }) })
      ] }),
      attachment.fileName && /* @__PURE__ */ jsx("span", { dir: "auto", children: attachment.fileName }),
      size && /* @__PURE__ */ jsx("small", { children: size })
    ] }, key);
  }) });
}
MessageAttachments.displayName = "MessageAttachments";
export {
  MessageAttachments
};
//# sourceMappingURL=MessageAttachments.mjs.map